import { useLanguage } from '../../context/LanguageContext';
import { valouseTranslations } from '../../translations/valouseTranslations';

const ChangeSection = () => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = valouseTranslations;

  return (
    <section id="changement" className="py-20 sm:py-32 px-6 bg-[#E8D2B5]/50">
      <div className="max-w-xl mx-auto text-center text-[#3F2A24]">

        {/* Context + Title */}
        <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059] mb-3">
          {t(tr.change.contextLine)}
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl mb-12">
          {t(tr.change.title)}
        </h2>

        {/* Stanzas */}
        <div className="space-y-10 sm:space-y-14">
          {tr.change.stanzas.map((stanza, i) => (
            <div key={i}>
              {i > 0 && (
                <div className="w-8 h-[1px] bg-[#C5A059]/40 mx-auto mb-10 sm:mb-14" />
              )}
              <p
                className="font-serif text-base sm:text-lg leading-[2.2] text-[#3F2A24]/85 whitespace-pre-line"
                style={{ textWrap: 'balance' }}
              >
                {t(stanza)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChangeSection;
